
























































/* General */
import Vue from 'vue'
import { debounce } from 'lodash'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import {
  ILinkedItemForListing,
  ISearchConversationResult,
} from '@/api/types/response.types'

/* API */
import SearchAPI from '@/api/modules/search.api'

export default Vue.extend({
  name: 'LinkExistingConversationsPanel',

  props: {
    currentlyLinkedConversations: {
      type: Array as () => ILinkedItemForListing[],
      required: true,
    },
  },

  data() {
    return {
      isSearching: false,
      searchQuery: '',
      debounceGetResults: null,
      matchingConversations: [] as ISearchConversationResult[],
      selectedConversationIds: [] as Number[],
      searchedOnce: false,
      minSearchLength: 2,
    }
  },

  computed: {
    matchingConversationsToDisplay(): ISearchConversationResult[] {
      const result = this.sortByMailbox(this.matchingConversations)
      return result
    },
    searchEmpty(): boolean {
      return this.searchQuery.length < this.minSearchLength
    },
    noMatchingConversations(): boolean {
      return this.matchingConversationsToDisplay.length === 0
    },
    showNoResults(): boolean {
      return (
        this.noMatchingConversations &&
        this.searchedOnce &&
        this.searchQuery.length >= this.minSearchLength
      )
    },
  },

  watch: {
    async searchQuery() {
      if (this.searchQuery.length >= 2) {
        await this.debounceGetResults()
        // @ts-ignore
        if (this.$refs.dropdownRef) {
          // @ts-ignore
          this.$refs.dropdownRef.$emit('visible', true)
        }
      } else {
        this.matchingConversations = [] as ISearchConversationResult[]
      }
    },
  },

  mounted() {
    // @ts-ignore
    this.$refs.searchRef.focus()
  },

  created() {
    this.debounceGetResults = debounce(this.getSearchConversationResults, 300)
  },

  methods: {
    // Show mailbox name if the indexed item has a different mailbox than its predecessor
    showMailboxName(index: number): boolean {
      if (index === 0) {
        return true
      }

      if (
        this.matchingConversationsToDisplay[index - 1].mailbox.id !==
        this.matchingConversationsToDisplay[index].mailbox.id
      ) {
        return true
      }
    },

    sortByMailbox(conversations: ISearchConversationResult[]) {
      conversations.sort(
        (a: ISearchConversationResult, b: ISearchConversationResult) => {
          if (a.mailbox.name.toLowerCase() < b.mailbox.name.toLowerCase()) {
            return -1
          }
          if (a.mailbox.name.toLowerCase() > b.mailbox.name.toLowerCase()) {
            return 1
          }
          if (a.isActive && !b.isActive) {
            return -1
          }
          if (!a.isActive && b.isActive) {
            return 1
          }
          return 0
        },
      )
      return conversations
    },

    // Only show description if there is a text match
    showDescription(conversation: ISearchConversationResult) {
      return conversation.description.includes('<span class="highlight">')
    },

    conversationAlreadyLinked(id: number): boolean {
      return this.currentlyLinkedConversations.some(t => t.id === id)
    },

    async getSearchConversationResults() {
      if (this.searchQuery === '') {
        return
      }
      this.isSearching = true

      let result = await SearchAPI.post_Conversations(this.searchQuery)

      // Scrub away already linked conversations, if matched...
      result = result.filter(t => !this.conversationAlreadyLinked(t.id))

      this.matchingConversations = result
      this.isSearching = false
      this.searchedOnce = true
      this.selectedConversationIds = []
    },

    linkSelectedConversation(id: number) {
      this.$emit('selected-existing-conversation-id', id)
    },
  },
})
